// 1 week before next year's renewal. MARKETING (PECR unsubscribe).

import type { EmailData } from "../../types";
import { anniversary, longDate } from "../../format";
import { b, body, call, esc, p } from "../../layouts/chrome";
import { callCta, plainEmailHtml } from "../../layouts/plain";
import { brand } from "../brand";

export const subject = (_data: EmailData) => `Days from renewal — get a better deal with ${brand.name}`;

export const html = (data: EmailData) =>
  plainEmailHtml({
    brand,
    data,
    callNumber: brand.callNumber,
    heading: "Don't renew without checking",
    cta: callCta(brand.callNumber),
    unsubscribeUrl: data.unsubscribeUrl,
    bodyHtml: body(
      p(
        `If ${b(`'${esc(data.companyName)}'`)} renews around ${b(longDate(anniversary(data.renewalDate)))}, this week is your chance to compare before you're locked in for another year.`,
      ),
      p(
        `Call ${brand.name} for a like-for-like quote — and claim your ${b("£25 Amazon voucher")} when your new policy starts.`,
      ),
      p(`We're on ${call(brand)} — call us before you commit.`),
      p(
        "£25 Amazon voucher: one per business, issued after your new policy has been active for 30 days. Ask our team for full terms.",
      ),
    ),
  });
